import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Modal, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import ClassCard from "../classes/ClassCard";
import { postMethod } from "../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard, faSpinner, faWarning } from "@fortawesome/free-solid-svg-icons";
import { faCalendarCheck, faCircleCheck, faCircleXmark /* , faUser */ } from "@fortawesome/free-regular-svg-icons";
import moment from "moment";

const Students2ClassModal = (props) => {
    const { t } = useTranslation();
    const { onClose, c } = props;
    const { checkServerData, changeView } = useContext(BasicContext);
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState(null);

    const getStudentsList = async () => {
        const res = await postMethod("/students-2-class-list", { classID: c.class_id });
        if (checkServerData(res)) {
            setList(res.data.list);
            setLoading(false);
        }
    };

    useEffect(() => {
        getStudentsList();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Modal show={true} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("classes.studentsList")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xs={12} className="mb-3">
                            <ClassCard c={c} />
                        </Col>

                        {loading ? (
                            <Col className="my-5 text-center">
                                <p className="h6">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        ) : list.length === 0 ? (
                            <Col xs={12}>
                                <p className="fs-5 opacity-75 text-center my-3">{t("classes.noStudentsOnList")}</p>
                            </Col>
                        ) : (
                            <Col xs={12}>
                                <Table className="white-table border">
                                    <tbody>
                                        {list.map((s, i) => (
                                            <Fragment key={i}>
                                                <tr>
                                                    <td className="border-bottom-0 pb-0">
                                                        <p className="mb-0">
                                                            {/*  <FontAwesomeIcon icon={faUser} className="me-2 d-inline" /> */}
                                                            <Button
                                                                variant="link"
                                                                size="sm"
                                                                className="p-0 text-small d-inline"
                                                                onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: s.user_id } })}
                                                            >
                                                                {s.user_name} {s.user_surname}
                                                            </Button>
                                                        </p>
                                                    </td>
                                                    <td className="border-bottom-0 pb-0 text-end">
                                                        {t("presence")}: {t(`attendanceCodes.${s.ua_status_code}`)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border-bottom-0 pb-0">
                                                        <FontAwesomeIcon icon={faCreditCard} className="me-2" />
                                                        {s.pass_name}
                                                    </td>
                                                    <td className="border-bottom-0 pb-0 text-end  lh-1">
                                                        {s.up_paid === 0 && s.up_price > 0 ? (
                                                            <span className="text-danger bold  text-small">
                                                                <FontAwesomeIcon icon={faCircleXmark} className="me-2" />
                                                                {t("passes.notPaid")}
                                                            </span>
                                                        ) : s.up_paid < s.up_price ? (
                                                            <span className="text-warning bold">
                                                                <FontAwesomeIcon icon={faWarning} className="me-2" />
                                                                {t("passes.notFullyPaid")}
                                                            </span>
                                                        ) : s.up_paid > s.up_price ? (
                                                            <span className="text-warning bold">
                                                                <FontAwesomeIcon icon={faWarning} className="me-2" />
                                                                {t("passes.overPaid")}
                                                            </span>
                                                        ) : (
                                                            <span className="text-success">
                                                                <FontAwesomeIcon icon={faCircleCheck} className="me-2" />
                                                                {t("passes.paid")}
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <FontAwesomeIcon icon={faCalendarCheck} className="me-2" />
                                                        {moment(s.u2c_create_date).format("YYYY-MM-DD HH:mm:ss")}
                                                    </td>
                                                    <td className="text-end">
                                                        {t("status")}: {t(`classes.studentStatus.${s.u2c_status_code}`)}
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                        )}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={onClose}>
                        {t("cancel")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default Students2ClassModal;
